import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Observable } from 'rxjs/index';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ReasonsService {
    constructor(private httpClient: HttpClient
    ) {
    }

    getReasons(userId: number): Observable<Array<any>> {
        const url = userId === null || userId === undefined ? '/servlets/reasons/' :
            `/servlets/reasons/?userid=${userId}`;

        return this.httpClient
            .get(url, {observe: 'body'})
            .pipe(
                map((response: any) => response)
            );
    }

    saveReasons(testCount, reasonId, strategyId): Observable<any>  {
        return this.httpClient
            .post(`servlets/reasons/${reasonId}/${strategyId}/`, {testCount: testCount});
    }
}
